import * as d3 from "d3";
import i18n from "../lang/lang";

export function ChartGauge(configuration, alias) {
  this.alias = alias;
  this.svg = {};
  this.hasErrorOnValueFormula = false;
  var self = this; // for internal d3 functions

  this.configure = function (configuration) {
    this.config = configuration;
    var element = d3.select("#" + this.alias).node();
    this.svgWidth = element.getBoundingClientRect().width;
    if (configuration.fullHeight) {
      this.svgHeight = element.getBoundingClientRect().width - 30;
      if (this.svgHeight > 200) {
        this.svgHeight = 200;
        this.svgWidth = 200 + 30;
      }
    } else {
      this.svgHeight = element.getBoundingClientRect().height - 50;
    }

    // set the dimensions and margins of the graph
    this.margin = configuration.margin || {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    };
    /* if (this.legend) {
      this.margin.bottom = 100
    }*/
    this.chartWidth = this.svgWidth - this.margin.left - this.margin.right;
    this.chartHeight = this.svgHeight - this.margin.top - this.margin.bottom;

    if (this.svgWidth <= this.svgHeight) {
      this.config.size = this.svgWidth;
    } else {
      this.config.size = this.svgHeight;
      var margin = (this.svgWidth - this.config.size) / 2;
      this.margin.right = margin;
      this.margin.left = margin;
    }

    this.config.radius = this.config.size / 2;
    this.config.cx = this.config.size / 2;
    this.config.cy = this.config.size / 2;

    this.config.min = undefined !== configuration.min ? configuration.min : 0;
    this.config.max = undefined !== configuration.max ? configuration.max : 100;
    this.config.range = this.config.max - this.config.min;

    this.config.majorTicks = configuration.majorTicks || 5;
    this.config.minorTicks = configuration.minorTicks || 2;

    this.config.greenColor = configuration.greenColor || "#009355";
    this.config.yellowColor = configuration.yellowColor || "#ffbe00";
    this.config.redColor = configuration.redColor || "#e60246";

    this.config.transitionDuration = configuration.transitionDuration || 500;
  };

  this.render = function () {
    this.svg = d3
      .select("#" + this.alias)
      .append("svg:svg")
      .attr("class", "gauge")
      .attr("width", this.svgWidth)
      .attr("height", this.svgHeight);

    this.body = this.svg
      .append("g")
      .attr(
        "transform",
        "translate(" + this.margin.left + "," + this.margin.top + ")"
      );

    /* this.body.append('svg:circle')
          .attr('cx', this.config.cx)
          .attr('cy', this.config.cy)
          .attr('r', this.config.radius)
          .style('fill', '#ccc')
          .style('stroke', '#000')
          .style('stroke-width', '0.5px')*/

    /* this.body.append('svg:circle')
          .attr('cx', this.config.cx)
          .attr('cy', this.config.cy)
          .attr('r', 0.9 * this.config.radius)
          .style('fill', '#fff')
          .style('stroke', '#e0e0e0')
          .style('stroke-width', '2px')*/
    // var Format = function (d) { return d + '%' }
    for (var index3 in this.config.redZones) {
      this.drawBand(
        this.config.redZones[index3].from,
        this.config.redZones[index3].to,
        self.config.redColor
      );
    }

    for (var index2 in this.config.yellowZones) {
      this.drawBand(
        this.config.yellowZones[index2].from,
        this.config.yellowZones[index2].to,
        self.config.yellowColor
      );
    }

    for (var index1 in this.config.greenZones) {
      this.drawBand(
        this.config.greenZones[index1].from,
        this.config.greenZones[index1].to,
        self.config.greenColor
      );
    }

    var fontSize = 0;
    if (undefined !== this.config.label) {
      fontSize = Math.round(this.config.size / 9);
      this.body
        .append("svg:text")
        .attr("x", this.config.cx)
        .attr("y", this.config.size - (fontSize + 16))
        .attr("dy", fontSize / 2)
        .attr("text-anchor", "middle")
        .text(i18n.tc(this.config.label))
        .style("font-size", fontSize + "px")
        .style("font-family", "Montserrat-Regular")
        .style("fill", "#333")
        .style("stroke-width", "0px")
        .style("font-weight", "600");
    }

    fontSize = Math.round(this.config.size / 16);
    var majorDelta = this.config.range / this.config.majorTicks;
    var point1 = 0;
    var point2 = 0;
    for (
      var major = this.config.min;
      major <= this.config.max;
      major += majorDelta
    ) {
      var minorDelta = majorDelta / this.config.minorTicks;
      for (
        var minor = major + minorDelta;
        minor < Math.min(major + majorDelta, this.config.max);
        minor += minorDelta
      ) {
        point1 = this.valueToPoint(minor, 0.75);
        point2 = this.valueToPoint(minor, 0.85);

        this.body
          .append("svg:line")
          .attr("x1", point1.x)
          .attr("y1", point1.y)
          .attr("x2", point2.x)
          .attr("y2", point2.y)
          .style("stroke", "#fff")
          .style("stroke-width", "1px");
      }

      point1 = this.valueToPoint(major, 0.7);
      point2 = this.valueToPoint(major, 0.85);

      this.body
        .append("svg:line")
        .attr("x1", point1.x)
        .attr("y1", point1.y)
        .attr("x2", point2.x)
        .attr("y2", point2.y)
        .style("stroke", "#fff")
        .style("stroke-width", "2px");

      var point = this.valueToPoint(major, 0.9);

      this.body
        .append("svg:text")
        .attr("x", point.x)
        .attr("y", point.y)
        .attr("text-anchor", () => {
          if (major < this.config.max / 2) {
            return "end";
          } else if (major === this.config.max / 2) {
            return "middle";
          } else {
            return "start";
          }
        })
        .text(major)
        .style("font-size", "0.8rem")
        .style("fill", "#333")
        .style("stroke-width", "0px")
        .style("font-family", "Oswald-Light");
    }

    if (this.hasErrorOnValueFormula !== "true") {
      var pointerContainer = this.body
        .append("svg:g")
        .attr("class", "pointerContainer");

      var midValue = (this.config.min + this.config.max) / 2;

      var pointerPath = this.buildPointerPath(midValue);

      var pointerLine = d3
        .line()
        .x(function (d) {
          return d.x;
        })
        .y(function (d) {
          return d.y;
        })
        .curve(d3.curveLinear);
      pointerContainer
        .selectAll("path")
        .data([pointerPath])
        .enter()
        .append("svg:path")
        .attr("d", pointerLine)
        .style("fill", "#00000")
        .style("stroke", "#676767")
        .style("fill-opacity", 0.7);

      pointerContainer
        .append("svg:circle")
        .attr("cx", this.config.cx)
        .attr("cy", this.config.cy)
        .attr("r", 0.12 * this.config.radius)
        .style("fill", "#ccc")
        .style("stroke", "#00000")
        .style("opacity", 1);

      fontSize = Math.round(this.config.size / 10);
      pointerContainer
        .selectAll("text")
        .data([midValue])
        .enter()
        .append("svg:text")
        .attr("x", this.config.cx)
        .attr("y", this.config.size - this.config.cy / 4 - fontSize)
        .attr("dy", fontSize / 2)
        .attr("text-anchor", "middle")
        .style("font-size", fontSize + "px")
        .style("fill", "#000")
        .style("stroke-width", "0px")
        .style("font-family", "Oswald-Light");
    }
    this.redraw(this.config.min, 0);
  };

  this.buildPointerPath = function (value) {
    var delta = this.config.range / 13;

    var head = valueToPoint(value, 0.85);
    var head1 = valueToPoint(value - delta, 0.12);
    var head2 = valueToPoint(value + delta, 0.12);

    var tailValue = value - (this.config.range * (1 / (270 / 360))) / 2;
    var tail = valueToPoint(tailValue, 0.28);
    var tail1 = valueToPoint(tailValue - delta, 0.12);
    var tail2 = valueToPoint(tailValue + delta, 0.12);

    return [head, head1, tail2, tail, tail1, head2, head];

    function valueToPoint(value, factor) {
      var point = self.valueToPoint(value, factor);
      point.x -= self.config.cx;
      point.y -= self.config.cy;
      return point;
    }
  };

  this.drawBand = function (start, end, color) {
    if (end - start <= 0) {
      return;
    }

    this.body
      .append("svg:path")
      .style("fill", color)
      .attr(
        "d",
        d3
          .arc()
          .startAngle(this.valueToRadians(start))
          .endAngle(this.valueToRadians(end))
          .innerRadius(0.5 * this.config.radius)
          .outerRadius(0.85 * this.config.radius)
      )
      .attr("transform", function () {
        return (
          "translate(" +
          self.config.cx +
          ", " +
          self.config.cy +
          ") rotate(270)"
        );
      });
  };

  this.redraw = function (value, transitionDuration, format) {
    var fontSize = Math.round(this.config.size / 13);
    var pointerContainer = this.body.select(".pointerContainer");
    var Format = function (d) {
      return d3.format(format || ".2f")(d);
    };
    pointerContainer
      .selectAll("text")
      .text(Format(value))
      .attr("dy", -fontSize / 2)
      .style("font-size", fontSize + "px")
      .style("font-family", "Montserrat-Regular");

    var pointer = pointerContainer.selectAll("path");
    pointer
      .transition()
      .duration(
        undefined !== transitionDuration
          ? transitionDuration
          : this.config.transitionDuration
      )
      // .delay(0)
      // .ease("linear")
      // .attr("transform", function(d)
      .attrTween("transform", function () {
        var pointerValue = value;
        if (value > self.config.max) {
          pointerValue = self.config.max + 0.02 * self.config.range;
        } else if (value < self.config.min) {
          pointerValue = self.config.min - 0.02 * self.config.range;
        }
        var targetRotation = self.valueToDegrees(pointerValue) - 90;
        var currentRotation = self._currentRotation || targetRotation;
        self._currentRotation = targetRotation;

        return function (step) {
          var rotation =
            currentRotation + (targetRotation - currentRotation) * step;
          return (
            "translate(" +
            self.config.cx +
            ", " +
            self.config.cy +
            ") rotate(" +
            rotation +
            ")"
          );
        };
      });
  };

  this.valueToDegrees = function (value) {
    // thanks @closealert
    // return value / this.config.range * 270 - 45;
    return (
      (value / this.config.range) * 270 -
      ((this.config.min / this.config.range) * 270 + 45)
    );
  };

  this.valueToRadians = function (value) {
    return (this.valueToDegrees(value) * Math.PI) / 180;
  };

  this.valueToPoint = function (value, factor) {
    return {
      x:
        this.config.cx -
        this.config.radius * factor * Math.cos(this.valueToRadians(value)),
      y:
        this.config.cy -
        this.config.radius * factor * Math.sin(this.valueToRadians(value)),
    };
  };
  this.setHasErrorOnValueFormula = function (errorOnValueFormula) {
    this.hasErrorOnValueFormula = errorOnValueFormula;
  };

  // initialization
  this.configure(configuration);
}
